import { Theme } from "@emotion/react";
import { Box, SxProps } from "@mui/material";
import React from "react";

interface Props {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const defaultStyles = {
  display: "flex",
  flex: 1,
  p: { xs: 2, md: 2.5, lg: 5 },
};

/**
 * @param {React.ReactNode} children - ReactNode
 * @param {SxProps} props.sx - override styles
 */
export default function LayoutMain({ children, sx }: Props) {
  return <Box sx={{ ...defaultStyles, ...sx }}>{children}</Box>;
}
